/*
  reports state mutations
*/
import { i18n } from '@/plugins/i18n'

function arrayToDict (array, key) {
  const result = {}
  for (let i = 0; i < array.length; i++) {
    result[array[i][key]] = array[i]
  }
  return result
}

export default {
  SET_LOADING (state, payload) {
    state.loading = payload
  },

  setList (state, payload) {
    state.list = payload
    // Convert state.list to dict list
    state.dictList = Object.assign({}, arrayToDict(state.list, 'id'))
  },
  setUnitList (state, { rootState }) {
    const list = []
    for (const i in state.list) {
      const unitList = []
      const object = state.list[i]
      // Search for the unit in the list
      const units = rootState.units.list.filter(item => object.units.includes(item.id))
      // If the unit is found, add it to the unitList
      if (units.length > 0) {
        for (const j in units) {
          const unit = units[j]
          unitList.push(unit)
        }
      }
      object.unitList = unitList
      object.unitsIds = object.units
      list.push(object)
    }
    state.list = list
  },
  addReport (state, payload) {
    state.list.push(payload)
    // Convert state.list to dict list
    state.dictList = Object.assign({}, arrayToDict(state.list, 'id'))
  },
  updateReport (state, payload) {
    const index = state.list.findIndex((item) => item.id === payload.id)
    state.list.splice(index, 1, payload)
  },
  setUnitsToList (state, { rootState, dispatch }) {
    const generateUnitName = (unitIds) => {
      const units = rootState.units.list.filter(unit => unitIds.includes(unit.id))
      if (units.length >= 4) {
        // Cut the units to 4
        return `${units.slice(0, 4).map(unit => unit.name).join(', ')}...`
      }
      return units.map(unit => unit.name).join(', ')
    }
    state.list = state.list.map((item) => {
      return {
        ...item,
        unitName: generateUnitName(item.units)
      }
    })
    // Set interval to call updateList every 120 seconds
    if (!state.intervalId) {
      state.intervalId = setInterval(() => { dispatch('reports/updateList', false, { root: true }) }, 1000 * 70)
    }
  },
  updateList (state, { rootState, payload, commit }) {
    const generateUnitName = (unitIds) => {
      const units = rootState.units.list.filter(unit => unitIds.includes(unit.id))
      if (units.length === 0) {
        return 'All Units'
      } else if (units.length >= 4) {
        // Cut the units to 4
        return `${units.slice(0, 4).map(unit => unit.name).join(', ')}...`
      }
      return units.map(unit => unit.name).join(', ')
    }
    // For Payload to update the state list
    const updateList = payload.map((item) => {
      return {
        ...item,
        unitName: generateUnitName(item.units)
      }
    })
    const updatedList = []
    // Update the state list but vlaidating if the item exists and the status change
    state.list = state.list.map((item) => {
      const updateItem = updateList.find((updateItem) => updateItem.id === item.id)
      if (updateItem && updateItem.status !== item.status) {
        updatedList.push(updateItem)
        return updateItem
      }
      return item
    })
    if (updatedList.length > 0) {
      // Commit an update for the snakbar
      commit('toggleSnackbar', { message: i18n.t('reports.success.reportsQuantity', { number: updateList.length }), color: 'green darken-2' }, { root: true })
    }
    state.dictList = Object.assign({}, arrayToDict(state.list, 'id'))
  },
  cleanInterval (state) {
    clearInterval(state.intervalId)
  },
  addIfToCompletedSessions (state, payload) {
    state.completedSessions.push(payload)
  },
  // eslint-disable-next-line no-unused-vars
  toggle (_, payload) {}
}
